import { useState, useEffect, useCallback } from 'react';
import axios from "axios";
import { ensureArray } from '../../../utils/validateResponseApi';
import { isNotEmptyObject } from '../../../utils/jsonValidator';
import { useDataAuth } from '../../../hooks/useDataAuth';

export default function useApiTrigger(config, filters) {
    const [{ userSession }] = useDataAuth();
    const [markers, setMarkers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const triggerApi = useCallback(async () => {
        const trigger = config?.maps?.[0]?.trigger;
        if (!trigger?.length) return;
        const apiConfig = trigger[0];
        setLoading(true);
        setError(null);
        try {
            let bodyData = { ...apiConfig.bodyData };
            if (isNotEmptyObject(filters)) {
                bodyData.variables = JSON.stringify({ filters });
            }
            const response = await axios({
                method: apiConfig.method,
                url: apiConfig.url,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${userSession?.token}`
                },
                data: bodyData
            });
            const rows = ensureArray(response.data?.data ?? response.data);
            const coords = rows
                .map(r => {
                    const lat = Number(r.latitude);
                    const lng = Number(r.longitude);
                    return (!isNaN(lat) && !isNaN(lng)) ? [lat, lng] : null;
                })
                .filter(Boolean);
            setMarkers(coords);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }

    }, [config, filters, userSession?.token]);

    useEffect(() => {
        triggerApi();
    }, [triggerApi]);

    return { markers, loading, error };
}
